import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'
import CustomContent from '../../customContent/CustomContent'
import { hakkimizdaData } from "./hakkimizdaData"

export default function Hakkimizda()
{
    const title = "OKAF Hakkında  - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF) hakkında detaylı bilgilere ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Hakkımızda"></PageTitle>
            <div class="container">
                <div class="singlePost my-4">
                    <CustomContent content={hakkimizdaData} />
                </div>
            </div>
        </>
    )
}